import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  IngehoudenDividendbelasting
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {Event, NavigationEnd, Router} from "@angular/router";
import {filter, Subscription} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-dividendbelasting',
  templateUrl: './dividendbelasting.component.html',
  styleUrls: ['./dividendbelasting.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class DividendbelastingComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public dividendBelasting = {} as FormGroup

    get ingehoudenDividendBelasting(): FormArray {
        return this.dividendBelasting.get('ingehoudenDividendBelasting') as FormArray;
    }

    addRij(): void {
        this.ingehoudenDividendBelasting.push(this.createDividendBelastingFormGroup())
    }

    createDividendBelastingFormGroup(dividend?: IngehoudenDividendbelasting): FormGroup {
        return this.fb.group<IngehoudenDividendbelasting>({
            dividendBox3: dividend?.dividendBox3 || undefined,
            dividendbelastingBox3: dividend?.dividendbelastingBox3 || undefined,
            dividendBox2: dividend?.dividendBox2 || undefined,
            dividendbelastingBox2: dividend?.dividendbelastingBox2 || undefined,
            rekeningNummer: dividend?.rekeningNummer || undefined
        })
    }

    verwijderRij(index: number): void {
        this.ingehoudenDividendBelasting.removeAt(index);
        this.dividendBelasting.updateValueAndValidity()
        this.dividendBelasting.markAsDirty()
        this.saveForm()
    }



    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.dividendBelasting = this.fb.group({
            ingehoudenDividendBelasting: this.fb.array<IngehoudenDividendbelasting>([]),
        });
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
        });
        this.routerSubscription = this.router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.dividendBelasting.dirty
    }

    private updateForm(): void {
        const dividendLijst = this.aangifte?.voorheffingen?.ingehoudenDividendbelasting || [];
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        const formArray = this.dividendBelasting.get('ingehoudenDividendBelasting') as FormArray;

        while (formArray.length > dividendLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < dividendLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(dividendLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createDividendBelastingFormGroup(dividendLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            voorheffingen: {
                ...this.aangifte.voorheffingen,
                ingehoudenDividendbelasting: this.dividendBelasting.value.ingehoudenDividendBelasting,
            }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
